<template>
	<div class="pl-column-edit-item" @click="handleClick">
		<keep-alive>
			<link-input-number
				v-if="!!lv_editable"
				v-model="showRow[field]"
				:max="max"
				:min="min"
				:space="space"
				:showIcon="showIcon"
				:align="align"
				:isInteger="isInteger"
				:step-strictly="stepStrictly"
				:precision="precision"

				:type="type"
				:color="color"
				:size="size"
				:shape="shape"
				:dashed="dashed"
				:long="long"
				:hideClearIcon="hideClearIcon"
				:disabled="disabled"
				:readonly="readonly"
				:focus-on-hover="focusOnHover"

				:required="lv_required"
				:validate-on-init="validateOnInit"
				:rules="rules"
				:regexp="regexp"
				:replacement="replacement"

				@change="e=>$emit('change',{row:showRow,value:e,field})"
			/>
			<template v-else>
				<link-table-cell-normal
					:render-func="null"
					:scope-slot-func="scopeSlotFunc"
					:text="showRow[field]"
					:data="scopeSlotData"/>
			</template>
		</keep-alive>
	</div>
</template>

<script>
	import {ColumnItemMixin} from "../mixins";
	import LvColumnText from "../lv-column-text";
	import LvScopeSlot from "../../render/lv-scope-slot";

	export default {
		name: "link-table-column-input-number-item",
		components: {LvScopeSlot, LvColumnText},
		mixins: [ColumnItemMixin],
		props: {
			dataType: {required: false, type: String},      //数据显示类型
			max: {type: Number},                            // 设置计数器最大值
			min: {type: Number},                            // 设置计数器最小值
			space: {type: Number, default: 1},              // 设置计数器每次增加的数量
			showIcon: {type: Boolean, default: true},       // 设置计数器上下icon的显示与隐藏
			align: {type: String},                          // input中文本的对其方式
			isInteger: {type: Boolean},                     // 是否只能输入整数
			stepStrictly: {type: Boolean},                  // 是否只能输入 space 的倍数
			precision: {type: [Number, String]},            // 数值精度

			type: {type: String, default: 'line',},
			color: {type: String, default: 'info',},
			size: {type: String, default: 'default',},
			shape: {type: String, default: 'fillet',},
			dashed: {type: Boolean}, // 设置input框的边框（无边框/虚线边框）
			long: {type: Boolean}, // 设置input框的长度为100%
			readonly: {type: Boolean}, // 设置input框的写入
			hideClearIcon: {type: Boolean},                             // 是否禁用清除图标
			disabled: {type: Boolean}, // 设置input框的只读
			focusOnHover: {},
			regexp: {type: RegExp, default: () => /[^\-0-9.]/g},        // 设置input框的校验
			replacement: {type: String, default: ''}                    //  设置替换文本或生成替换文本的函数
		},
	}
</script>
